import { createEntityCollectionStore } from '@core/ngrx-legacy';
import { JobBoardPosting } from '@recruitee/job-boards-types';

const { actions, namespace, selectors, reducer } = createEntityCollectionStore<JobBoardPosting>()(
  'JobBoardCredentialPostings',
);

export {
  actions as JobBoardCredentialPostingActions,
  namespace as JobBoardCredentialPostingNamespace,
  reducer as JobBoardCredentialPostingReducer,
  selectors as JobBoardCredentialPostingSelectors,
};
